// packages block
import { Box, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { FC, useContext } from 'react'
// other block
import { UserRole, UsersInput } from '../../../generated'
import { AppContext } from '../../context'
import { ActionType } from '../../context/AppContextReducer'
import { SearchWithSortProps } from '../../interfaceTypes'
import { anchorOrigin, transformOrigin } from '../../theme/styleConstants'
import { SEARCHABLE_USER_ROLES } from '../../constants'

export const RoleFilter: FC<SearchWithSortProps> = ({ sortByRole, setSearch, loading }): JSX.Element => {
  const { dispatch, isLoading, userRoles } = useContext(AppContext)
  // No single role picked means every role is listed, so the dropdown reads "All"
  const role = userRoles?.length === 1 ? userRoles[0] : 'all'

  const handleChange = (event: SelectChangeEvent) => {
    const { value } = event.target

    if (dispatch) {
      dispatch({
        type: ActionType.SET_USER_ROLES,
        userRoles: value === 'all' ? SEARCHABLE_USER_ROLES : ([value] as UsersInput['roles'])
      })
      dispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 })
      dispatch({ type: ActionType.SET_SEARCH_VALUE, searchValue: '' })
      setSearch && setSearch('')
    }
  }

  const roleWithoutRespondent = sortByRole?.filter(role => role.value !== UserRole.SuperAdmin)

  return (
    <Box display="flex" alignItems="center" gap="16px">
      <InputLabel id="sortByRole-label">Role:</InputLabel>

      <Select
        labelId="sortByRole-select-label"
        id="sortByRole-select"
        onChange={handleChange}
        disabled={isLoading || loading}
        value={role}
        size="small"
        sx={{ width: 130 }}
        MenuProps={{ anchorOrigin: anchorOrigin, transformOrigin: transformOrigin }}
      >
        <MenuItem value="all">All</MenuItem>

        {roleWithoutRespondent?.map((item, index) => {
          const { label, value } = item

          return (
            <MenuItem sx={{ width: 130 }} value={value} key={`${label}-${index}`}>
              {label}
            </MenuItem>
          )
        })}
      </Select>
    </Box>
  )
}
